const styles = {
  headerRow: {
    gridColumn: '1 / -1',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'flex-start', md: 'center' },
    justifyContent: 'space-between',
  },
  pageTitle: {
    fontFamily: 'Source Sans Pro',
    fontWeight: 600,
    fontSize: { xs: '1.75rem', sm: '2.375rem' },
    lineHeight: '100%',
    color: '#5236AB',
  },
};

export default styles;
